import * as React from 'react';

import {PaginationSettings} from '@deviceinsight/ng-ui-api-client';
import {DataProcessingDefinition} from '../../../../../../api/dataProcessingDefinitionApi';
import {ReactableColumnDef, ReactableWithClientSidePagination} from '@deviceinsight/ng-ui-components';

import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import {getColumnDefs} from './columnDefs/kpis';

type Props = {
	kpis: Array<DataProcessingDefinition> | null | undefined;
	isFetchingKpis: boolean;
	onSelectKpi: (arg0: DataProcessingDefinition) => any;
};
const initialPaginationSettings: PaginationSettings = {
	page: 0,
	size: 10,
	sort: {
		property: 'name',
		direction: 'ASC'
	}
};
export default class KpiSelectionTable extends React.Component<Props> {
	columnDefs: Array<ReactableColumnDef<DataProcessingDefinition>> = getColumnDefs(this.props.onSelectKpi);

	render() {
		const {kpis, isFetchingKpis} = this.props;
		return (
			<div>
				<h2>
					<Trans i18nKey="dashboard.widgets.kpiaggredatedchart.kpiselection.title">
						Please select a Kpi...
					</Trans>
				</h2>
				<ReactableWithClientSidePagination
					columnDefs={this.columnDefs}
					uniqueItemKey={(kpi) => kpi.id}
					paginationSettings={initialPaginationSettings}
					items={kpis}
					isLoading={isFetchingKpis}
				/>
			</div>
		);
	}
}
